import React from 'react'
import { connect } from 'react-redux'
import HeaderNewClear from '../partials/HeaderNewClear.jsx'
import FooterNew from '../partials/FooterNew.jsx'
import taPro01 from '../../images/ta-pro-01.png'
import taPro02 from '../../images/ta-pro-02.png'
import taPro03 from '../../images/ta-pro-03.png'
import { usersGetDetailAsync } from '../../actions/users.js'
import { Link } from 'react-router-dom'
import { accesslog, translate } from '../../helpers/global.js'
import { getWeeklyDemoDataAsync } from '../../actions/global';

class TaPro extends React.Component {
    constructor(props) {
    super(props);
  }

	async componentDidMount() {
		window.scrollTo(0, 0)
    if (!this.props.weeklyDemoData || !this.props.weeklyDemoData.webinar_link) {
      await this.props.getWeeklyDemoDataAsync();
    }
	}

  render() {
    const { globalGetLanguages, weeklyDemoData } = this.props;
    return (
			<div id="homepage">
        <HeaderNewClear isOnStatusFor="is-on" />
        <div className="section-top-solution relative bg-gray" style={{
          position: 'relative',
          paddingTop: '120px',
        }}>
          <div className="gray-curve-bottom-left" style={{ backgroundColor: '#F7F7FC' }}></div>
          <section className='flex-container' style={{zIndex: '2'}}>
            <div className='flex-item-left' style={{ flex:'55%' }}>
              <div className='vertical-item--center'>
                <div className="sec-desc">
                  <h1>
                    Hiring Experienced Professionals with Confidence
                  </h1>
                  <p>
                    Make Every Decision Count When Hiring Mid-Level and Senior Talent
                  </p>
                  <p className='text-normal-2'>
                    Successful professional hiring isn’t about finding “qualified” candidates. It’s about
                    confidently identifying which candidates can lead, collaborate, and grow with your 
                    business. ASTRNT helps you bring structure, fairness, and clarity into every step of
                    the process.
                  </p>
                  <div className={`ban-link`} style={globalGetLanguages == 'id' ? {margin: '0'} : {margin: '8px 0 0'}}>
                    <a onClick={() => {
                      document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                      accesslog('talent-acquisition/professional', 'button_talk_to_an_expert');
                    }} className="request-demo-logged">{translate(globalGetLanguages,'HOMEPAGE_BUTTON_REQUEST_DEMO')}</a>
                    <a href={weeklyDemoData.webinar_link} target="_blank" className={`btn btn-secondary-red${weeklyDemoData.webinar_link != null ? '' : ' hide'}`}
                      onClick={() => accesslog('talent-acquisition/professional', 'button_register_for_demo')}
                    >Register for Demo</a>
                  </div>
                </div>
              </div>
            </div>
            <div className='flex-item-right flex-container flex-end align-items-center' style={{ flex:'45%' }}>
              <div className='horizontal-item--center'>
                <img className='img-100' src={taPro01} />
              </div>
            </div>
          </section>
        </div>
        <div className="section-white" style={{overflow: 'hidden'}}>
          <section className='flex-container' style={{zIndex: '2'}}>
            <div className='flex-item-right flex-container flex-end align-items-center flex-padding-1'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={taPro02} />
              </div>
            </div>
            <div className='flex-item-left flex-padding-1 p-l-80'>
              <div className='vertical-item--center'>
                <h1 className='title-2'>
                  The Challenge of Professional Hiring Today
                </h1>
                <p className='sub-title-1 text-justify'>
                  Experienced hires often come with good resumes and seemingly strong backgrounds. Very commonly this leads to overconfident and incorrect selection decisions made with heavily imperfect data and under time pressure. Making the final call is rarely simple.
                </p>
                <ul className='list-1 m-t-25'>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        Dozens of applicants with similar experience
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        Inconsistent interview quality across panels
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        Long turnaround time from screening to offer
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        No structured way to compare soft skills or culture fit
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        Candidates who are already working and have limited availability
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </section>
        </div>
        <div className="section-white" style={{overflow: 'hidden'}}>
          <section className='flex-container' style={{zIndex: '2'}}>
            <div className='flex-item-left'>
              <div className='vertical-item--center'
                style={{
                  padding: '0 60px',
                }}
              >
                <h1 className='title-2'>
                  How ASTRNT Supports Professional Hiring
                </h1>
                <ul className='list-1 m-t-25'>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        <b>Structured Video Interview</b>
                        <p>Replace unstructured phone screens with consistent, asynchronous interviews that show how candidates communicate and think.</p>
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        <b>Role-Based Assessment</b>
                        <p>Use real tasks, case simulations, or situational judgment to evaluate how candidates approach complex problems.</p>
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        <b>AI Scoring</b>
                        <p>Score responses instantly and fairly using consistent criteria. Surface top candidates based on how well they align with your expectations.</p>
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <div className='red-dot'></div>
                      <p className='text-normal-1'>
                        <b>Candidate Insights</b>
                        <p>View performance breakdowns, notes, and fit indicators in one workspace.</p>
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className='flex-item-right flex-container flex-end align-items-center'>
              <div className='horizontal-item--center'>
                <img className='img-100' src={taPro03} />
              </div>
            </div>
          </section>
        </div>
        <div className="section-white bg-gray center"
          style={{
            textAlign: '-webkit-center',
            minHeight: '366px',
            padding: '56px 0',
            position: 'relative',
          }}
        >
          <div className='gray-triangle-bottom-right'>
            <div className='gray-small-triangle-bottom-right'></div>
          </div>
          <div>
            <h1 className='title-1'>
              Build Stronger Teams by Hiring
              <br />
              the Right People
            </h1>
            <p style={{
              margin: '20px 0',
            }}>
              When hiring professionals, every decision matters. ASTRNT helps you make them with
              <br />
              structure, speed, and confidence.
            </p>
            <div>
                <div className="ban-text-start-demo">
                <div className={`ban-link`}>
                  <Link onClick={() => {
                    document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                    accesslog('talent-acquisition/professional', 'button_talk_to_an_expert');
                  }} className="try">Talk to an Expert</Link>
                  <a href={weeklyDemoData.webinar_link} target="_blank" className={`request-demo-logged${weeklyDemoData.webinar_link != null ? '' : ' hide'}`}
                    onClick={() => accesslog('talent-acquisition/professional', 'button_register_for_demo')}
                  >Register for Demo</a>
                </div>
                </div>
            </div>
          </div>
        </div>
        <FooterNew />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
	return {
    globalGetLanguages:state.globalGetLanguages,
    user: state.user,
    weeklyDemoData: state.weeklyDemo.weeklyDemoData 
	}
}

const mapDispatchToProps = (dispatch) => {
  return {
    usersGetDetailAsync: (user) => dispatch(usersGetDetailAsync(user)),
    getWeeklyDemoDataAsync: () => dispatch(getWeeklyDemoDataAsync())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TaPro)
